<!-- Tab "MCP-Connectoren" of /tutors/:id/setup — the host owns the tutor menu and the card. -->
<div [nbSpinner]="loading || saving">
<section class="tile-flat" *ngIf="enabledSetting">
  <header class="tile-flat__header">
    <h5>{{ "pages.learnings.settingsTitle" | translate }}</h5>
  </header>
  <app-tutor-settings [tutorSetting]="enabledSetting" [tutor]="tutor"></app-tutor-settings>
  <p class="hint warn" *ngIf="!featureEnabled">{{ "pages.mcp.agent.disabledHint" | translate }}</p>
</section>

<section class="tile-flat">
  <header class="tile-flat__header">
    <h5>{{ "pages.mcp.agent.connectorsTitle" | translate }}</h5>
  </header>
  <p class="hint">
    {{ "pages.mcp.agent.toolCount" | translate: { count: assignedToolCount, max: maxTools } }}
    <a *ngIf="canAssign" routerLink="/agent-setup/mcp">{{ "pages.mcp.agent.manage" | translate }}</a>
  </p>
  <p class="hint" *ngIf="!rows.length && !loading">
    {{ (canAssign ? "pages.mcp.agent.noneAtClient" : "pages.mcp.agent.noneAssigned") | translate }}
  </p>

  <ul class="connectors">
    <li *ngFor="let row of rows; trackBy: trackRow">
      <div class="connector-head">
        <nb-checkbox
          *ngIf="canAssign"
          [checked]="row.assigned"
          [nbTooltip]="'pages.mcp.tooltips.assign' | translate"
          (checkedChange)="toggleAssigned(row, $event)"
        ></nb-checkbox>
        <strong>{{ row.connector.name }}</strong>
        <span class="badge" [class.badge--on]="row.connector.is_active">
          {{ (row.connector.is_active ? "pages.mcp.status.active" : "pages.mcp.status.inactive") | translate }}
        </span>
      </div>
      <p class="hint">
        {{ "pages.mcp.agent.connectorTools" | translate: { count: row.enabledTools } }}
        <ng-container *ngFor="let tool of row.connector.tools">
          <code *ngIf="tool.is_enabled && !tool.removed">{{ tool.agent_tool_name }}</code>
        </ng-container>
      </p>
      <p class="hint warn" *ngIf="row.assigned && !row.connector.is_active">
        {{ "pages.mcp.agent.assignedButInactive" | translate }}
      </p>
    </li>
  </ul>
</section>
</div>
